/* eslint-disable @typescript-eslint/no-explicit-any */
import { privateClient } from "@/api/privateClient";
import { ORG_ADMIN_ENDPOINTS } from "../../orgAdmin.endpoints";
import type { OrgDashboardStats, OrgEntity } from "../types";

export const listMyOrgEntities = async (organizationId: number): Promise<OrgEntity[]> => {
  const [campusesRes, institutionsRes] = await Promise.all([
    privateClient.get(ORG_ADMIN_ENDPOINTS.CAMPUSES.LIST_BY_ORG(organizationId)),
    privateClient.get(ORG_ADMIN_ENDPOINTS.INSTITUTIONS.LIST_BY_ORG(organizationId)),
  ]);

  const rawCampuses = campusesRes.data.campuses ?? [];
  const rawInstitutions = institutionsRes.data.institutions ?? [];

  const campuses: OrgEntity[] = rawCampuses.map((c: any) => ({
    id: c.id,
    type: "CAMPUS",
    name: c.name,
    code: c.code,
    logoUrl: c.logoUrl,
    status: c.isActive ? "ACTIVE" : "INACTIVE",
  }));

  const institutions: OrgEntity[] = rawInstitutions.map((i: any) => ({
    id: i.id,
    type: "INSTITUTION",
    name: i.name,
    code: i.code,
    logoUrl: i.logoUrl,
    parentCampusName: i.campusId ? rawCampuses.find((c: any) => c.id === i.campusId)?.name : undefined,
    status: i.isActive ? "ACTIVE" : "INACTIVE",
  }));

  return [...campuses, ...institutions];
};

export const getOrgDashboardStats = async (
  organizationId: number
): Promise<OrgDashboardStats> => {
  const { data } = await privateClient.get(
    ORG_ADMIN_ENDPOINTS.DASHBOARD.STATS(organizationId)
  );

  return data;
};
